export default value => {

  if (!value) return '';
  value = Math.abs(value);
  let v1 = Math.floor(value);//度
  let v2 = Math.floor((value - v1) * 60);//分
  let v3 = Math.floor((value - v1) * 3600 % 60);//秒
  return v1 + '°' + v2 + '\'' + v3 + '"';
};



// WEBPACK FOOTER //
// ./src/filters/formatDegree.js